import { Wallet, TrendingUp, CalendarClock, Layers, ShieldAlert, Radio, RefreshCw, Lock } from "lucide-react";
import { fmtUsd, pnlColor } from "../lib/format";
import { useAgo } from "../lib/useAgo";

function Card({ icon: Icon, label, children, testid, accent }) {
  return (
    <div className="bg-[#121724] border border-[#1E2738] rounded-lg p-4 hover:border-[#2A364F] transition-colors">
      <div className="flex items-center gap-1.5 text-[#64748B] text-[11px] font-semibold uppercase tracking-wider mb-1.5">
        <Icon className="h-3.5 w-3.5" style={accent ? { color: accent } : {}} /> {label}
      </div>
      <div data-testid={testid} className="font-mono">{children}</div>
    </div>
  );
}

export default function V2MetricsBar({ status, p = "v2" }) {
  const v2 = status?.[p] || {};
  const b0 = p === "v3" ? status?.v3_b0 : status?.b0;
  const m = v2.metrics || {};
  const st = v2.state || {};
  const risk = v2.risk || {};
  const ago = useAgo(m.ts);
  const wsOk = v2.ws_connected;
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-2 flex-wrap text-[11px] font-mono text-[#64748B]">
        <div data-testid="v2-test-banner" className="px-2.5 py-1 rounded border border-[#F59E0B]/60 bg-[#F59E0B]/15 text-[#F59E0B] font-bold tracking-wide">
          TEST — SANAL BAKİYE · {v2.strategy || "Trend Yönünde Geri Çekilme V2"} · {v2.host_label}
        </div>
        <div data-testid="metrics-last-update" className="flex items-center gap-1.5">
          <RefreshCw className="h-3 w-3" /> Risk/metrik güncellendi: <span className="text-[#94A3B8]">{ago}</span>
          <span className="mx-1">·</span>
          <Radio className={`h-3 w-3 ${wsOk ? "text-[#10B981]" : "text-[#EF4444]"}`} /> WS {wsOk ? "bağlı" : "kopuk (REST yedeği)"}
        </div>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4">
        <Card icon={Wallet} label="Demo Hesap / Test Bütçesi (B0)" testid="demo-balance-display">
          <div className="text-base sm:text-lg font-bold text-[#F1F5F9]">
            {st.demo_wallet != null ? `$${fmtUsd(st.demo_wallet)}` : "—"}
          </div>
          <div data-testid="initial-capital-display" className="text-xs text-[#64748B]">
            B0: ${fmtUsd(b0)} {st.demo_available != null && <span>· kullanılabilir ${fmtUsd(st.demo_available)}</span>}
          </div>
        </Card>
        <Card icon={TrendingUp} label="Bot Özsermayesi / Toplam Net" testid="current-equity-display" accent="#3B82F6">
          <div className="text-base sm:text-lg font-bold text-[#F1F5F9]">${fmtUsd(m.equity ?? b0)}</div>
          <div className={`text-xs ${pnlColor((m.equity ?? 0) - (m.b0 ?? 0))}`}>
            Toplam: ${fmtUsd((m.equity ?? b0 ?? 0) - (m.b0 ?? b0 ?? 0))} · Realize ${fmtUsd(m.realized_net || 0)}
          </div>
        </Card>
        <Card icon={CalendarClock} label="Günlük Net (00:00 İst.)" testid="daily-pnl-display" accent="#F59E0B">
          <div className={`text-base sm:text-lg font-bold ${pnlColor(m.daily_pnl)}`}>${fmtUsd(m.daily_pnl || 0)}</div>
          <div className="text-xs text-[#64748B]">Günlük kayıp %{Number(m.daily_loss_pct || 0).toFixed(2)} / limit %5</div>
        </Card>
        <Card icon={Layers} label="Açık / Bekleyen" testid="open-count-display" accent="#10B981">
          <div className="text-base sm:text-lg font-bold text-[#F1F5F9]">{m.open_count ?? 0} / {status?.max_positions ?? 10}</div>
          <div className="text-xs text-[#64748B]">Bekleyen sinyal: {v2.pending_signals ?? 0} · Evren: {v2.universe_count ?? 0} coin ({v2.universe_source === "coingecko" ? "CoinGecko" : "Binance vadeli"} ilk {v2.top_mcap ?? 100})</div>
        </Card>
        <Card icon={risk.active || st.entries_locked ? ShieldAlert : Lock} label="Risk Kilidi / Giriş Kilidi" testid="risk-lock-badge" accent={risk.active || st.entries_locked ? "#EF4444" : "#10B981"}>
          <div className={`text-base sm:text-lg font-bold ${risk.active || st.entries_locked ? "text-[#EF4444]" : "text-[#10B981]"}`}>
            {risk.active ? "RİSK KİLİDİ" : st.entries_locked ? "GİRİŞ KİLİDİ" : "Normal"}
          </div>
          <div className="text-xs text-[#64748B] truncate" title={st.lock_reason || (risk.reasons || []).join("; ")}>
            {risk.active ? (risk.reasons || []).join("; ") : st.entries_locked ? st.lock_reason : `Toplam kayıp %${Number(m.total_loss_pct || 0).toFixed(2)} / limit %5`}
          </div>
        </Card>
      </div>
    </div>
  );
}
